import { render, staticRenderFns } from "./GetCoupon.vue?vue&type=template&id=452f6a52&"
import script from "./GetCoupon.vue?vue&type=script&lang=js&"
export * from "./GetCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports